/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Empty_Nocollection_Title2Inputs */

const id_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada koleksi yang dipilih`)
};

const ms_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada koleksi dipilih`)
};

const da_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen samling valgt`)
};

const de_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Sammlung ausgewählt`)
};

const en_us2_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No collection selected`)
};

const es_es2_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha seleccionado ningún ranking`)
};

const es_mx2_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin colección seleccionada`)
};

const fil_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang napiling koleksyon`)
};

const fr_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune collection sélectionnée`)
};

const it_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna collezione selezionata`)
};

const hu_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs gyűjtemény kiválasztva`)
};

const nl_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen collectie geselecteerd`)
};

const no_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen samling valgt`)
};

const pl_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie wybrano kolekcji`)
};

const pt_br2_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma coleção selecionada`)
};

const pt_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma coleção selecionada`)
};

const ro_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicio colecție selectată`)
};

const fi_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokoelmaa ei valittu`)
};

const sv_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen samling vald`)
};

const vi_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa chọn bộ sưu tập`)
};

const tr_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksiyon seçilmedi`)
};

const cs_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Není vybrána žádná kolekce`)
};

const bg_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма избрана колекция`)
};

const ru_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подборка не выбрана`)
};

const uk_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колекцію не вибрано`)
};

const ar_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم اختيار مجموعة`)
};

const hi_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई कलेक्शन चयनित नहीं`)
};

const th_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ได้เลือกคอลเล็กชัน`)
};

const ja_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コレクションが選択されていません`)
};

const zh_cn2_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择合集`)
};

const zh_hant1_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未選擇合集`)
};

const ko_components_performancetable_empty_nocollection_title2 = /** @type {(inputs: Components_Performancetable_Empty_Nocollection_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선택된 차트 없음`)
};

/**
* | output |
* | --- |
* | "No collection selected" |
*
* @param {Components_Performancetable_Empty_Nocollection_Title2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_empty_nocollection_title2 = /** @type {((inputs?: Components_Performancetable_Empty_Nocollection_Title2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Empty_Nocollection_Title2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "ms") return ms_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "da") return da_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "de") return de_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "fil") return fil_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "fr") return fr_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "it") return it_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "hu") return hu_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "nl") return nl_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "no") return no_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "pl") return pl_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "pt") return pt_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "ro") return ro_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "fi") return fi_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "sv") return sv_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "vi") return vi_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "tr") return tr_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "cs") return cs_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "bg") return bg_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "ru") return ru_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "uk") return uk_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "ar") return ar_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "hi") return hi_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "th") return th_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "ja") return ja_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_empty_nocollection_title2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_empty_nocollection_title2(inputs)
	return ko_components_performancetable_empty_nocollection_title2(inputs)
});
export { components_performancetable_empty_nocollection_title2 as "components.performanceTable.empty.noCollection.title" }